import { Box, Button, Typography } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../context/themeContext";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateNotFound } from "../../../store/slices/infoSlice";
import { setIsPageLoading } from "../../../store/slices/loadingSlice";

const NotFound = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { isOpen, heading, body } = useSelector((state) => state.info.notFound);
  // const redirectUrl = localStorage.getItem("redirectUrl");
  const dispatch = useDispatch();

  return (
    <Box
      className={styles.container}
      sx={{
        bgcolor: theme.palette.lightgrey.lightgrey500,
        display: isOpen ? "flex" : "none",
      }}
    >
      <Box className={styles.basics}>
        <Box
          className={styles.icon}
          sx={{ bgcolor: theme.palette.lightgrey.lightgrey500 }}
        >
          <Box className={styles.successIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="88"
              height="88"
              viewBox="0 0 88 88"
              fill="none"
            >
              <path
                d="M43.9987 80.6673C64.2491 80.6673 80.6654 64.2511 80.6654 44.0007C80.6654 23.7502 64.2491 7.33398 43.9987 7.33398C23.7483 7.33398 7.33203 23.7502 7.33203 44.0007C7.33203 64.2511 23.7483 80.6673 43.9987 80.6673Z"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M55 33L33 55"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M33 33L55 55"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Box>
        </Box>
        <Box className={styles.content}>
          <Box className={styles.text}>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.darkgrey.darkgrey700,
                fontSize: "1.5rem",
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              {heading}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.darkgrey.darkgrey500,
                fontSize: "1rem",
                fontWeight: 400,
                textAlign: "center",
              }}
            >
              {body}
            </Typography>
          </Box>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              dispatch(setIsPageLoading(true));
              dispatch(updateNotFound({ isOpen: false }));
              navigate(-1);
            }}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export { NotFound };
